fx.ns("shared.component", class Person extends fx.components.Box{
    
	constructor(asset, className)
	{
		super("Person");

        this._asset = asset || fx.assets.personAdvice;
        this._className = className || "image";
    }

    get person()
    {
        return this._person;
    }

    get src()
    {
        return this.person ? this.person.src : null;
    }

    set src(val)
    {
        if (this.person)
            this.person.src = val;
        else
            this._asset = val;
    }

    create()
    {
        super.create();

        this._person = new fx.components.Image({data : this._asset, className : this._className});
		let circle1 = new fx.components.Box("circle1");
		let circle2 = new fx.components.Box("circle2");
		
		this.addChild(circle1);
		this.addChild(circle2);
		this.addChild(this._person);
    }

});